import { Pipe } from '@angular/core';
import { Injectable } from '@angular/core';

@Pipe({
  name: 'TypesFilter'
})
@Injectable()
export class TypesFilter {
  transform(items, args) {
    // console.log(items, items.length);
    return items.filter(hero => {
      let flag =
        hero.type && hero.type.toLowerCase().indexOf(args.toLowerCase()) >= 0;
      if (!hero.type && args.length == 0) flag = true; //if all and item has no type
      return flag;
    });
  }
}
@Pipe({
  name: 'StatusFilter'
})
@Injectable()
export class StatusFilter {
  transform(items, args) {
    let itms = true;
    if (typeof args === 'string') {
      itms = items.filter(
        hero => hero.status.toLowerCase().indexOf(args.toLowerCase()) >= 0
      );
    } else {
      itms = items.filter(hero => {
        let match = args.filter(status => {
          return status.toLowerCase().indexOf(hero.status.toLowerCase()) >= 0;
        });
        return match.length > 0;
      });
    }
    return itms;
  }
}

export function getValue(checkObject, properties: string) {
  if(!checkObject || !properties) return null;
  const props = properties.split('.');
  let obj = checkObject;
  props.some(prop => {
    obj = obj[prop];
    if (!obj) return true;
  });
  return obj;
}



// WEBPACK FOOTER //
// ./src/providers/tasks/filters.ts